export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1);
};

export const lowercaseFirstLetter = (string) => {
  return string?.charAt(0).toLowerCase() + string?.slice(1);
};

export const isEmpty = (value) => {
  return value === undefined || value === null || value === '' || isNaN(value);
};

export const returnDefaultValueWhileEmpty = (value, defaultValue = null) => {
  if (isEmpty(value)) {
    return defaultValue
  }
  return value
}